"use client";
import * as React from "react";
import { startSignIn } from "@/lib/sign-in";

export function SigninPill() {
  return (
    <button
      type="button"
      onClick={() => void startSignIn("/")}
      className="signin-pill"
      style={{ background: "none", border: 0, padding: 0, cursor: "pointer" }}
    >
      Sign in with Google
    </button>
  );
}
